module.exports = "ul, p{\n    margin-bottom: 0px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/course-one/course-one.component.css
// module id = ./src/app/course-one/course-one.component.css
// module chunks = main